import React from 'react';
import styled from 'styled-components';

import { FontWeight } from '@prisjakt/ui/text';
import HighlightedSearchResult from 'src/areas/product-collection/components/products/highlighted-search-result';

type Props = {
  query: string;
  children: string;
};

export const HighlightedName = (props: Props) => {
  const { query, children } = props;
  const escapedRegExpQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(escapedRegExpQuery, 'gi');
  const highlight = children.match(re) || [];
  const highlightedName = children.replace(
    re,
    `[highlight]${highlight[0] || ''}[/highlight]`
  );

  return (
    // NOTE: Don't let Google translate this as it will cause a client crash
    <Text className="notranslate">
      <HighlightedSearchResult component={Highlight}>
        {highlightedName || ''}
      </HighlightedSearchResult>
    </Text>
  );
};

const Text = styled.span`
  font-weight: ${FontWeight.HEAVIEST};
`;

const Highlight = styled.span`
  font-weight: ${FontWeight.NORMAL};
`;
